export const DEMO_INVOICE_CONTENT_MAX_WIDTH = 1208
